module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"英国式リフレクソロジー Reverie レヴェリー","short_name":"Reverie レヴェリー","start_url":"/","background_color":"#ffffff","theme_color":"#F5C651","display":"minimal-ui","icon":"./src/images/manifest.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"ae7888d7e8e0aee75bab1eec66bb54c3"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
